import React from "react";
import Landing from "./Landing";
import Services from "./Services";
import Contact from "./Contact";
import Approach from "./Approach";

const Content = () => {
  return (
    <main id="home">
      <Landing />
      <Services />
      <Approach />
      <Contact />
    </main>
  );
}

export default Content;
